import { useState, useEffect } from 'react';
import { Store } from '../types/store';
import { getStores } from '../services/storeApi';

export function useStores() {
    const [stores, setStores] = useState<Store[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchStores = async () => {
            try {
                setIsLoading(true);
                const response = await getStores();
                setStores(response.data.data);
            } catch (err) {
                setError('Failed to fetch stores');
            } finally {
                setIsLoading(false);
            }
        };

        fetchStores();
    }, []);

    return { stores, isLoading, error };
} 